export default "__VITE_ASSET__fdfbe84f__"